import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBars, FaBell, FaUserCircle, FaSignOutAlt } from "react-icons/fa";
import { useAuth } from "../../hooks/useAuth";
import styles from "./Header.module.css";

const Header = ({ onToggleSidebar, isSidebarOpen }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    if (isLoggingOut) return;

    setIsLoggingOut(true);

    try {
      await logout();
        navigate("/login", { replace: true });
    } catch (error) {
      console.error("Logout error:", error);
      navigate("/login", { replace: true });
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <button
          className={styles.menuToggle}
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <FaBars />
        </button>
        <h1 className={styles.brandTitle}>ADMIN - IFILLIP</h1>
      </div>

      <div className={styles.headerRight}>
        <button className={styles.iconButton} aria-label="Notifications">
          <FaBell />
          <span className={styles.notificationBadge}>3</span>
        </button>

        <div className={styles.userMenu}>
          <button className={styles.userButton}>
            <FaUserCircle className={styles.userIcon} />
            <span className={styles.userName}>{user?.name || "Admin"}</span>
          </button>
          <div className={styles.dropdownMenu}>
            <a href="/dashboard/profile" className={styles.dropdownItem}>
              <FaUserCircle />
              <span>Profile</span>
            </a>
            <button
              className={styles.dropdownItem}
              onClick={handleLogout}
              disabled={isLoggingOut}
            >
              <FaSignOutAlt />
              <span>{isLoggingOut ? "Logging out..." : "Logout"}</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
